import { useState, useRef, useEffect } from "react";

export const useContainerHeight = () => {
  const [containerHeight, setContainerHeight] = useState<number>(0);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const tabsRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (tabsRef.current) {
      setContainerHeight(tabsRef.current.clientHeight);
    } else {
      if (containerRef.current) setContainerHeight(containerRef.current.clientHeight);
    }
  }, []);

  return {
    containerRef,
    tabsRef,
    containerHeight,
  };
};
